export const shouldSkipSysAdminPatientContentQuery = (userId?: string, patientProfileId?: string) => !userId && !patientProfileId;

export const shouldSkipSysAdminLifeReviewQuery = shouldSkipSysAdminPatientContentQuery;
